const tcRatingToLetter = (rating) => {
    if (rating > 0.90){
      return "F";
    }
    if (rating > 0.70){
      return "D";
    }
    if (rating > 0.40){
      return "C";
    }
    if (rating > 0.15){
      return "B";
    }
    return "A";
};

const userLetterToRating = (letter) => {
  if (letter === "A"){
    return 1.0;
  }
  if (letter === "B"){
    return 0.85;
  }
  if (letter === "C"){
    return 0.55;
  }
  if (letter === "D"){
    return 0.30;
  }
  return 0.0;
};

const userRatingToLetter = (rating) => {
  if (rating > 0.90){
    return "A";
  }
  if (rating > 0.70){
    return "B";
  }
  if (rating > 0.40){
    return "C";
  }
  if (rating > 0.15){
    return "D";
  }
  return "F";
};

const compLetterToRating = (letter) => {
  if (letter === "A"){
    return 1.0;
  }
  if (letter === "B"){
    return 0.85;
  }
  if (letter === "C"){
    return 0.55;
  }
  if (letter === "D"){
    return 0.30;
  }
  return 0.0;
};

const compRatingToLetter = (rating) => {
  if (rating > 0.90){
    return "A";
  }
  if (rating > 0.70){
    return "B";
  }
  if (rating > 0.40){
    return "C";
  }
  if (rating > 0.15){
    return "D";
  }
  return "F";
};

export { tcRatingToLetter, userLetterToRating, userRatingToLetter, compLetterToRating, compRatingToLetter };